import { Component, OnInit, AfterViewChecked, ElementRef } from '@angular/core'
import { User } from './models/user';
import { AuthenticationService, AuthService } from './services/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Location } from '../../node_modules/@angular/common';
import { Globals } from './common/globals';
import { CookieService } from 'ngx-cookie-service';
import { ReportsService } from './reports/reports.service';
import { EnvironmentsService } from './services/enviornment.service';
import { Http } from '@angular/http';
import { ApiService } from './services/api.service';
import { UserService } from './services/user.service'
import { TranslateService } from '@ngx-translate/core';
import { AuthInterceptor } from './services/auth.interceptor';
import { interval } from 'rxjs/observable/interval';
import { JwtHelper } from 'angular2-jwt';
import { timer } from 'rxjs/observable/timer';

@Component({
    selector: 'configmax-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewChecked {
    ngAfterViewChecked(): void {
        const iframe = this.hostElement.nativeElement.querySelector('iframe');
        if (iframe && iframe.src != this.envService.config.fbSrc) {
            iframe.src = this.envService.config.fbSrc;
        }
    }

    private subscription: Subscription;
    userObjRole: any;
    langSub: Subscription;
    timerSub: Subscription;
    showSidenav: boolean = false;
    currentUser: User;
    showFeedbackModal: boolean = false;
    message: string = null;
    isUserLoggedIn: any;
    menuItems = [];
    list = [];
    headerIcons = [];
    currentLocale: string = 'en';
    showLanguage: boolean;
    selectedLanguage: string;
    timeLimit: number = 30000;
    copyrightDate: string;


    constructor(private globals: Globals,
        private http: Http,
        private envService: EnvironmentsService,
        private authenticationService: AuthenticationService,
        private authService: AuthService,
        private reportService: ReportsService,
        private router: Router, private location: Location,
        private cookieService: CookieService, private hostElement: ElementRef,
        private apiService: ApiService,
        private userService: UserService,
        private route: ActivatedRoute,
        private translateService: TranslateService,
        private authIntercept: AuthInterceptor,
        private jwtHelper: JwtHelper
    ) {
        this.copyrightDate = (new Date()).getFullYear().toString();
        this.translateService.setDefaultLang('en');
        this.translateService.use('en');
        this.subscription = authenticationService.getMessage().subscribe(message => { this.isUserLoggedIn = message; this.loadAuthorizedMenuItems(); });
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        /**
         * Open for all menu Item
         */
        if (currentUser == null) {
            this.setLoginContext();
        }
        authenticationService.verifyLogin();
    }

    logout() {
        localStorage.clear();
        window.location.reload();
    }

    /**
     * If login info available in URL Params, this function sets login context
     * This is needed when Employee logs in
     */
    setLoginContext() {
        /*reading parameters for saml redirect*/
        let tokenStr = this.authService.decodeTokenStr(localStorage.getItem('token'))
        if (tokenStr) {
            let userInfo = {
                "userName": tokenStr['acct'],
                "email": tokenStr['acct'],
                "token": localStorage.getItem('token'),
                "expiry": tokenStr['exp'],
                "loginTypeId": 1,
                "roleIds": this.reportService.roleIds
            };
            localStorage.setItem('currentUser', JSON.stringify(userInfo));
        }
    }

    /**
     * This functions takes care of loading authorized menu items
     */
    loadAuthorizedMenuItems(): void {
        this.menuItems = [];
        this.menuItems.push({ caption: this.translateService.instant('subNav.viewLimits'), link: ['/guest'], btntype: 'btn-primary' });
        this.menuItems.push({ caption: this.translateService.instant('subNav.compareLimits'), link: ['repcomp/compare'], hidden: false });
        let token: any = localStorage.getItem("token");
        if (token != "" && token != null) {
            let key = {
                token: token
            }
            this.apiService.login(key).subscribe((apiresponse: any) => {
                let response = JSON.parse(apiresponse._body);
                let tokenex: any = this.authService.isTokenNotExpired();
                if (null != response && tokenex) {
                    this.reportService.roleIds = response["rid"];
                    this.reportService.authRoleIds = response["ari"];
                    let actions: any[] = response["act"];
                    this.reportService.resorceactions = actions;
                    let arr: any = [];
                    let showMenus = this.isResourceAuthorized("CRET_NEW_CMS", this.reportService.resorceactions);
                    this.menuItems.push({ caption: this.translateService.instant('subNav.manageLimits'), link: ['reports/limits'], hidden: false });
                    if (showMenus === false) {
                        this.menuItems.push({ caption: this.translateService.instant('subNav.review&Publish'), link: ['review/list'], hidden: false });
                        this.menuItems.push({ caption: this.translateService.instant('subNav.admin'), link: ['admin/managereleases'], hidden: false });
                    }
                } else {
                    this.logout();
                }
            })
            this.setLoginContext();
        }

    }

    loadTranslatedMenuItems() {
        let linkToText = {
            "/guest": 'subNav.viewLimits',
            "repcomp/compare": "subNav.compareLimits",
            "reports/limits": "subNav.manageLimits",
            "review/list": "subNav.review&Publish",
            "admin/managereleases": "subNav.admin"
        }
        let auxMenu = [];
        this.menuItems.forEach(
            (ele) => {
                auxMenu.push({ caption: this.translateService.instant(linkToText[ele.link[0]]), link: ele.link, hidden: ele.hidden })
            }
        )
        this.menuItems = auxMenu;
    }
    /**
     * Check if given resource is present in user authorized resource actions.
     * @param resourceName - Resource for which admin belongs to
     * @param resourceActions  - List of resource actions which logged in user belongs to.
     */
    isResourceAuthorized(resourceName, resourceActions = []): boolean {
        this.changeLanguage(localStorage.getItem('configmax-lang') ? localStorage.getItem('configmax-lang') : 'en');
        let hideComponent = true;
        let found = resourceActions.indexOf(resourceName);
        if (found >= 0) {
            hideComponent = false;
            return hideComponent;
        }
        return hideComponent;
    }

    getUsername() {
        let userObj = this.userService.getUser();
        return userObj ? userObj["username"] : '';
    }

    getRole() {
        let userObj1 = this.userService.getUser();
        return userObj1 ? userObj1["rol"] : '';
    }

    toggle(): void {
        this.showSidenav = !this.showSidenav;
    }

    ngOnInit() {
        this.checkSessionExpiry();
        this.reportService.loadFontFiles();
        this.timerSub = interval(5000).subscribe(
            () => {
                this.authIntercept.intercept();
            }
        )
        this.langSub = this.envService.selectedLanguage$.subscribe((lang) => {
            this.translateService.setDefaultLang('en');
            this.headerIcons = [
                { iconShape: 'user', menu: [{ caption: this.translateService.instant('nav.signIn'), link: [this.authenticationService.getCSPLoginUrl()] }] }
            ];
        },
            err => { this.langSub.unsubscribe(); }, () => this.langSub.unsubscribe());
        if (this.location.path(false).indexOf("/admin") > -1) {
            this.router.navigate(['/']);
        }
        setTimeout(() => {
            this.changeLanguage(localStorage.getItem('configmax-lang') ? localStorage.getItem('configmax-lang') : 'en');
        }, 0);
    }

    updateSelectedLang() {
        if (localStorage.getItem('configmax-lang') === null || localStorage.getItem('configmax-lang') === 'en') {
            this.selectedLanguage = 'English'
        }
        else if (localStorage.getItem('configmax-lang') === 'ja') {
            this.selectedLanguage = '日本語'
        }
        else if (localStorage.getItem('configmax-lang') === 'zh') {
            this.selectedLanguage = ' 中文'
        }
    }
    changeLanguage(lang: string, notify: boolean = false) {
        this.translateService.use(lang).subscribe(
            () => {
                this.loadTranslatedMenuItems();
                if (notify) {
                    this.notifyChangeLang();
                }
            }
        )
        this.showLanguage = false;
        localStorage.setItem('configmax-lang', lang);
        this.updateSelectedLang();
        this.reportService.loadFontFiles();
    }

    notifyChangeLang() {
        this.envService.selectedLang = this.selectedLanguage;
        this.envService.selectedLanguage.next(this.selectedLanguage);
    }

    onLanguageClick() {
        this.showLanguage = true;
    }

    onCancelClick() {
        this.showLanguage = false;
    }

    checkSessionExpiry() {
        const accessToken = this.userService.getToken();
        if (!accessToken) {
            return;
        }
        if (accessToken && this.isValidToken(accessToken) && this.isAboutExpire(accessToken)) {
            this.refreshAccessToken();
        }
        else {
            let timeToExpireMillie = this.jwtHelper.getTokenExpirationDate(accessToken).getTime() - new Date().getTime();
            const subscription = timer(timeToExpireMillie - this.timeLimit).subscribe(() => {
                this.refreshAccessToken();
            });
        }
    }

    refreshAccessToken() {
        const refreshToken = this.userService.getRefreshToken() || '';
        this.userService.clearCurrentSession();
        this.apiService.refreshToken(refreshToken).subscribe(
            (session: any) => {
                this.userService.saveCurrentSession(session);
                this.userService.saveToken(JSON.parse(session._body).body.access_token)
            },
            (error) => {
                // Token refresh failed
            }
        );
    }
    //check if the token is about to exprie in 30seconds
    isAboutExpire(token: string): boolean {
        let timeToExpireMillie = this.jwtHelper.getTokenExpirationDate(token).getTime() - new Date().getTime();
        return timeToExpireMillie <= this.timeLimit && timeToExpireMillie > 0;
    }

    isValidToken(token): boolean {
        try {
            let str = this.jwtHelper.decodeToken(token);
            return true;
        }
        catch {
            return false;
        }
    }

    ngOnDestroy() {
        this.langSub.unsubscribe();
        this.timerSub.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts